module.exports = {
  "newsAndInformation": {},
};



// WEBPACK FOOTER //
// ./src/i18n/newsAndInformation/en.js